import { Check, TrendingUp, Clock, ShoppingCart } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "@/lib/currencyFormatter";

interface StatCard {
  titleKey: string;
  value: number | string;
  descriptionKey: string;
  icon: string;
  trend?: "up" | "down";
  trendValue?: string;
  isMonetary?: boolean;
}

interface DashboardStatsCardsProps {
  stats: StatCard[];
  isLoading: boolean;
}

export const DashboardStatsCards = ({
  stats,
  isLoading,
}: DashboardStatsCardsProps) => {
  const { t } = useTranslation();
  let statValue = "";

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => {
        statValue = stat.value as string;
        if (stat.icon === "ShoppingCart") {
          statValue = stat.value as string;
        }
        if (stat.icon === "TrendingUp") {
          statValue = formatCurrency(Number(stat.value));
        }
        if (stat.icon === "Check") {
          statValue = stat.value as string;
        }
        if (stat.icon === "Clock") {
          statValue = stat.value as string;
        }
        return (
          <Card key={stat.titleKey} className="animate-fade-in">
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium">
                {t(stat.titleKey)}
              </CardTitle>
              <div
                className={`h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center`}
              >
                {stat.icon === "ShoppingCart" && (
                  <ShoppingCart className="h-5 w-5 text-primary" />
                )}
                {stat.icon === "TrendingUp" && (
                  <TrendingUp className="h-5 w-5 text-primary" />
                )}
                {stat.icon === "Check" && (
                  <Check className="h-5 w-5 text-primary" />
                )}
                {stat.icon === "Clock" && (
                  <Clock className="h-5 w-5 text-primary" />
                )}
              </div>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">
                {isLoading ? "..." : statValue}
              </div>
              <p
                className={`text-xs ${
                  stat.trend === "up" ? "text-green-600" : "text-red-600"
                }`}
              >
                {isLoading
                  ? t("loading")
                  : stat.trendValue || t(stat.descriptionKey)}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
